import clientLogo from "@assets/images/CESIF_ISOTIPO.png";
import PersonIcon from "@mui/icons-material/Person";
import { Box, List, ListItem, Typography } from "@mui/material";

export enum AvatarChatHistoryMessageSource {
  USER = "user",
  AVATAR = "avatar"
}

export interface IAvatarChatHistoryMessage {
  source: AvatarChatHistoryMessageSource;
  text: string;
  timestamp: Date;
}

export interface IAvatarChatHistoryProps {
  messages: IAvatarChatHistoryMessage[];
}

const formatDate = (date: Date): string => {
  const numberFormat = { minimumIntegerDigits: 2 };
  const hours = date.getHours().toLocaleString("en-US", numberFormat);
  const minutes = date.getMinutes().toLocaleString("en-US", numberFormat);
  const seconds = date.getSeconds().toLocaleString("en-US", numberFormat);
  return `${hours}:${minutes}:${seconds}`;
};

const AvatarChatHistory = ({ messages }: IAvatarChatHistoryProps) => {
  const chatMessages = messages.map((message, index) => (
    <ListItem
      key={index}
      sx={{
        justifyContent:
          message.source === AvatarChatHistoryMessageSource.USER
            ? "flex-end"
            : "flex-start",
        px: 2
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          maxWidth: "80%",
          flexDirection:
            message.source === AvatarChatHistoryMessageSource.USER
              ? "row-reverse"
              : "row"
        }}
      >
        {message.source === AvatarChatHistoryMessageSource.AVATAR ? (
          <img
            src={clientLogo}
            alt="Avatar"
            style={{
              width: 23,
              height: 35,
              borderRadius: "10%"
            }}
          />
        ) : (
          <PersonIcon
            sx={{
              fontSize: 35,
              color: "primary.main",
              bgcolor: "background.paper",
              borderRadius: "50%",
              p: 0.5,
              border: "1px solid #cfcfcf"
            }}
          />
        )}

        <Box
          sx={{
            bgcolor:
              message.source === AvatarChatHistoryMessageSource.AVATAR
                ? "background.paper"
                : "customColors.syntetis",
            color:
              message.source === AvatarChatHistoryMessageSource.AVATAR
                ? "text.primary"
                : "primary.contrastText",
            p: 2,
            borderRadius: 3,
            boxShadow: 0.5,
            border:
              message.source === AvatarChatHistoryMessageSource.AVATAR
                ? "1px solid #e1e1e1"
                : "",
            position: "relative",
            maxWidth: "100%"
          }}
        >
          <Typography
            variant="body1"
            sx={{
              textAlign: "justify",
              fontSize: { xs: 12, sm: 15 },
              overflowWrap: "break-word"
            }}
          >
            {message.text}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              mt: 1,
              color:
                message.source === AvatarChatHistoryMessageSource.AVATAR
                  ? "text.secondary"
                  : "#fff",
              textAlign: "right",
              fontSize: "0.7rem"
            }}
          >
            {formatDate(message.timestamp)}
          </Typography>
        </Box>
      </Box>
    </ListItem>
  ));

  return (
    <>
      <List
        sx={{
          flex: 1,
          overflow: "auto",
          bgcolor: "background.default",
          "&::-webkit-scrollbar": { width: 8 },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "primary.main",
            borderRadius: 2
          }
        }}
      >
        {chatMessages}
      </List>
    </>
  );
};

export default AvatarChatHistory;
